module.exports = __webpack_public_path__ + "static/media/eSports.0932205a.svg";